import {
  PieChart,
  Cell,
  Tooltip,
  Pie,
  PieLabelRenderProps,
} from 'recharts';

export const COLORS = [
  '#002C4E',
  '#005AFF',
  '#4B5058',
  '#9DA1A1',
  '#FFCC00',
  '#FFFFFF',
];

export interface dataObject {
  name: string;
  value: number;
  color: string;
}

interface IParams {
  disabled: boolean;
  data: dataObject[];
}

export const ColoredPie = ({ disabled, data }: IParams) => {
  const chartKey = data.map((d) => `${d.name}:${d.value}`).join(',');
  return disabled ? (
    <PieChart key={chartKey} width={200} height={200}>
      <Pie
        className="text-xs"
        data={data}
        cx="50%"
        cy="50%"
        labelLine={false}
        label={renderCustomizedLabel}
        outerRadius={80}
        fill="#8884d8"
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.color} />
        ))}
      </Pie>
      <Tooltip />
    </PieChart>
  ) : (
    <div></div>
  );
};

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}: PieLabelRenderProps) => {
  const numCx = Number(cx);
  const numCy = Number(cy);
  const radius =
    Number(innerRadius) +
    (Number(outerRadius) - Number(innerRadius)) * 0.5;
  const x = numCx + radius * Math.cos(-Number(midAngle) * RADIAN);
  const y = numCy + radius * Math.sin(-Number(midAngle) * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > numCx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {`${((percent ?? 0) * 100).toFixed(0)}%`}
    </text>
  );
};

const RADIAN = Math.PI / 180;
